<ng-template #errorForm>
  <div class="churning-exceded-cont">
    <div class="churning-exceded-support-img">
      <img alt="churning" *ngIf="imageUrl" class="churning-exceded-img" loading="lazy" [src]="imageUrl | ImageCdn">
    </div>
    <div class="churning-exceded-body">
      <h3 class="error-title">{{title}}</h3>
      <p class="error-description">{{description}}</p>
    </div>
    <div class="churning-exceded-actions">
      <div class="main">
        <app-ds-button
          [labels]="{ ButtonLabel: textButton }"
          (clickEvent)="mainButton.emit()">
        </app-ds-button>
      </div>
    </div>
    <div class="churning-exceded-actions" *ngIf="textSecondaryButton">
      <div class="close">
        <app-ds-button
          [type]="cancelBtnDsType"
          [labels]="{ ButtonLabel: textSecondaryButton }"
          (clickEvent)="secondaryButton.emit()">
        </app-ds-button>
      </div>
    </div>
  </div>
</ng-template>

<ng-container *ngIf="isMobile">
  <app-swipe-up [height]="95" [classType]="'app-bg'" [showSwipeUp]="true">
    <ng-container content>
      <ng-container *ngTemplateOutlet="errorForm"></ng-container>
    </ng-container>
  </app-swipe-up>
</ng-container>

<ng-container *ngIf="isMobile === false">
  <app-modal [width]="640">
    <ng-container content>
      <ng-container *ngTemplateOutlet="errorForm"></ng-container>
    </ng-container>
  </app-modal>
</ng-container>